<template>
	<div class="search-container" v-if="historyList.length > 0">
		<!-- 搜索历史 -->
		<div class="section">
			<div class="section-header">
				<div class="title">
					<span>搜索历史</span>
					<div class="bottom"></div>
				</div>

				<van-icon @click="clearHistory" class="clear-his" v-if="historyList.length > 0" name="delete-o" />
			</div>
			<div class="history-tags">
				<van-tag
					class="his-tag"
					@click="searchText(item)"
					closeable
					v-for="(item, index) in historyList"
					:key="item + index"
					@close="close(item)"
				>
					{{ item }}
				</van-tag>
			</div>
			<div class="no-his" v-if="historyList.length == 0">暂无数据</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		historyList: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			searchVal: '',
			searchList: [],
		};
	},
	methods: {
		close(item, index) {
			this.$emit('del', item, index);
		},
		searchText(text) {
			this.$emit('search', text);
		},
		clearHistory() {
			this.$emit('clearHis');
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
<style scoped lang="scss">
.no-his {
	text-align: center;
	padding: 4px;
}
.search-container {
	background: #fff;
	padding: 0px 12px;
}

/* 标题行 */
.section-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-weight: bold;
	color: #333;
	font-size: 14px;
	margin-bottom: 10px;
	height: 40px;
	.title {
		display: flex;
		align-items: center;
		flex-direction: column;
		.bottom {
			width: 58px;
			height: 5px;
			background: linear-gradient(90deg, #6696fd -16%, #bbf9fd 95%);
		}
	}
}

.section-header i {
	display: inline-block;
	padding: 3px;
	margin-right: 2px;
	font-size: 16px;
}

/* 搜索历史标签 */
.history-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 8px;
}

.his-tag {
	display: inline-block;
	background: #f0f2f7;
	color: #333;
	border-radius: 3px;
	padding: 4px 10px !important;
	font-size: 12px !important;
	cursor: pointer;
	letter-spacing: 0px;
}

.his-tag :hover {
	background: #e8e9eb;
}

/* 搜索发现 */
.discover-list {
	display: flex;
	flex-wrap: wrap;
	gap: 10px 25px;
}

.discover-item {
	width: 45%;
	display: flex;
	align-items: center;
	line-height: 24px;
	font-size: 14px;
	cursor: pointer;
	color: #333;
	transition: color 0.2s;
}

.discover-item:hover {
	color: #409eff;
}

.index {
	display: inline-block;
	width: 18px;
	height: 18px;
	text-align: center;
	line-height: 18px;
	border-radius: 50%;
	background: #f2f3f5;
	margin-right: 6px;
	font-size: 12px;
	color: #666;
}
</style>
